import { createAction } from "redux-actions";
import { UserState } from "./redux";

export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const setCurrentUserAction = createAction<UserState>(SET_CURRENT_USER);

